import React, { useState } from 'react';
import CloseIcon from '@mui/icons-material/Close';
import CheckIcon from '@mui/icons-material/Check';

const months = [
  "January", "February", "March", "April", "May", "June",
  "July", "August", "September", "October", "November", "December"
];

export function MonthPickerModal({ isOpen, onClose, onSelect, selectedValue }) {
  // Track which month is being hovered to simulate CSS :hover
  const [hoveredMonth, setHoveredMonth] = useState(null);

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-[9999] flex items-center justify-center bg-black/40">
      <div className="bg-white w-full max-w-[500px] rounded-md shadow-lg overflow-hidden">

        {/* Header */}
        <div className="flex flex-row items-center justify-between p-7 border-b border-gray-200">
          <h3 style={{ margin: 0, fontSize: '1.125rem', fontWeight: 700, color: '#668fca' }}>
            Select Month
          </h3>
          <div
            style={{ cursor: 'pointer', color: '#9ca3af' }}
            onClick={onClose}
          >
            <CloseIcon fontSize="small" />
          </div>
        </div>

        {/* Body */}
        <div className="p-7">
          <div className="grid grid-cols-2 gap-2 max-h-[300px] overflow-y-auto">
            {months.map((month) => {
              const isSelected = selectedValue === month;
              const isHovered = hoveredMonth === month;

              return (
                <button
                  key={month}
                  onClick={() => onSelect(month)}
                  onMouseEnter={() => setHoveredMonth(month)}
                  onMouseLeave={() => setHoveredMonth(null)}
                  style={{
                    // Layout
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                    padding: '12px 16px',
                    borderRadius: '6px',
                    fontSize: '14px',
                    transition: 'all 0.2s ease',
                    cursor: 'pointer',
                    width: '100%',
                    outline: 'none',

                    // BORDER: Priority to Selected, then Hover, then Default
                    border: isSelected
                      ? '2px solid #668fca'
                      : isHovered
                        ? '1px solid #668fca'
                        : '1px solid #e0e0e0',

                    // BACKGROUND
                    backgroundColor: isSelected
                      ? '#eef4ff'
                      : isHovered
                        ? '#f0f7ff'
                        : '#ffffff',

                    // TEXT COLOR
                    color: isSelected
                      ? '#1a75ff'
                      : isHovered
                        ? '#668fca'
                        : '#4b5563',

                    // FONT WEIGHT
                    fontWeight: isSelected ? '700' : '400',
                  }}
                >
                  {month}
                  {isSelected && (
                    <CheckIcon style={{ color: '#1a75ff', fontSize: '18px' }} />
                  )}
                </button>
              );
            })}
          </div>
        </div>

        {/* Footer */}
        <div style={{ padding: '12px 20px', backgroundColor: '#f9fafb', borderTop: '1px solid #e5e7eb', textAlign: 'right' }}>
          <button
            onClick={onClose}
            style={{
              background: 'none',
              border: 'none',
              color: '#6b7280',
              fontSize: '14px',
              cursor: 'pointer'
            }}
          >
            Close
          </button>
        </div>
      </div>
    </div>
  );
}